import {useRetrieveRawTransactionQuery} from '@transactions/graphql';
import * as React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useBreadcrumb} from 'src/Breadcrumbs';
import RawTransactionDetail from 'src/DetailComponents/RawTransaction/Detail';
import Empty from 'src/ListView/Empty';
import Loading from 'src/Loading';

const RawTransactionDetailPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const rawTransactionId = params.id || '';
  const {data, loading} = useRetrieveRawTransactionQuery({
    variables: {id: rawTransactionId},
  });

  useBreadcrumb({
    label: data?.rawTransaction?.description ?? rawTransactionId,
    fallback: [{label: 'Activity', href: '/ledger?layer=activity'}],
  });

  if (!rawTransactionId) {
    return <Empty>No raw transaction selected</Empty>;
  }

  if (loading && !data) {
    return <Loading size="medium" />;
  }

  const rawTransaction = data?.rawTransaction;

  if (!rawTransaction) {
    return <Empty>Raw transaction not found</Empty>;
  }

  return (
    <div className="flex flex-1 flex-col overflow-y-auto p-8">
      <RawTransactionDetail
        rawTransaction={rawTransaction}
        onDelete={() =>
          navigate(`/accounts/${rawTransaction.account._id}/transactions`)
        }
      />
    </div>
  );
};

export {RawTransactionDetailPage};
